import { Box, Paper, Typography } from '@mui/material';
import React from 'react';

export default function ASZF() {
  return (
    <Box mt={4} display='flex' justifyContent='center'>
      <Paper
        elevation={3}
        sx={{
          width: '100%',
          maxWidth: 1200,
          p: 2,
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <Typography variant='h5' textAlign='center' gutterBottom>
          Általános Szerződési Feltételek
        </Typography>
        <Box sx={{ height: 1000, mt: 2 }}>
          <iframe
            title='ÁSZF dokumentum'
            width='100%'
            height='100%'
            style={{ border: 'none' }}
            src='https://api.virtualjog.hu/api/v1/document/5199?access-token=6f9b181fedb920cdd2e2f0024a249c8d'
          />
        </Box>
      </Paper>
    </Box>
  );
}
